import React from "react";
import { useSelector } from "react-redux";
import { SkeletonLine } from "Components/Skeletion";
import { useTranslation } from 'react-i18next';

function PriceDetailSection() {
  const { cartDetails } = useSelector((state) => ({
    cartDetails: state?.cartItems?.[0],
  }));
const { t } = useTranslation();
  const {
    totals_detail: totals,
    tax_details: tax,
    shippingTitle,
  } = cartDetails || {};
  const renderRow = (label, value, isFree = false) => (
    <tr>
      <td>{label}</td>
      <td className={`${ label === "Instelkosten" && value ? "no-translate notranslate" : "" }`}>
        {isFree || value === "0,00" ? (
           <b className="normal green no-translate notranslate">{t("Gratis")}</b>
        ) : (
          <span className="no-translate notranslate">{value}</span>
        )}
      </td>
    </tr>
  );

  if (!totals?.items?.length) {
    return (
      <div className="priceDetails pt-6 pb-4">
        <table className="w-1/1">
          {Array.from({ length: 4 }).map((_, index) => (
            <tr key={index}>
              <td className="pb-2">
                <SkeletonLine width="100%" height="30px" />
              </td>
            </tr>
          ))}
        </table>
      </div>
    );
  }

  return (
    <div className="priceDetails pt-4 pb-4">
      <table className="w-1/1">
        {totals?.isSample !== "1" && (
          <>
            {renderRow("Digitale drukproef", "", true)}
            {renderRow("Instelkosten", totals?.setupCost)}
          </>
        )}

        {totals?.postageCosts !== null &&
          renderRow(shippingTitle, totals?.postageCosts)}

        {totals?.productCost &&
          Object.values(totals.productCost).map((item, index) => (
            <tr key={index}>
              <td>{item?.label}</td>
              <td className="no-translate notranslate">{item?.productCost}</td>
            </tr>
          ))}

        {totals?.couponCode && (
          <tr>
            <td><span className="no-translate notranslate">{t("Kortingscode")}</span> ({totals?.couponCode})</td>
            <td className="no-translate notranslate">-{totals?.discount_amount}</td>
          </tr>
        )}

         {totals?.custom_price?.length > 0 && (
          Object.entries(
            totals.custom_price.reduce((acc, item) => {
              const label = item.label;
              const value = parseFloat(item.value);
              acc[label] = (acc[label] || 0) + value;
              return acc;
            }, {})
          ).map(([label, total], index) => (
            <tr key={`custom-price-${index}`}>
              <td>{label}</td>
              <td>{total.toFixed(2).replace('.', ',')}</td>
            </tr>
          ))
        )}


        <tr className="fw-700">
          <td className="fs-20 no-translate notranslate">
              {t("Totaal (excl. BTW)")}
            </td>
          <td className="fs-26 no-translate notranslate">{tax?.subtotal_original}</td>
        </tr>

         {/* <tr>
          <td><span className="no-translate notranslate">{t("BTW")}</span></td>
          <td className="no-translate notranslate">{tax?.tax_amount}</td>
        </tr> */}
        
              {
          tax?.tax_breakdown &&
          (
            tax.tax_breakdown.every(item => item.tax_amount === "0,00") ? (
              <tr>
                <td className="no-translate notranslate">{"BTW 0%"}</td>
                <td className="no-translate notranslate">0,00</td>
              </tr>
            ) : (
              tax.tax_breakdown.map((taxItem, index) => (
                <tr key={index}>
                <td className="no-translate notranslate">
                  {`${t("BTW")}${taxItem?.tax_amount !== "0,00" ? ` ${taxItem?.tax_rate}% ${taxItem?.country_code}` : ""}`}
                </td>
                  <td className="no-translate notranslate">{taxItem?.tax_amount}</td>
                </tr>
              ))
            )
          )
        }
        <tr>
          <td className="no-translate notranslate">{t("Totaalbedrag")}</td>
          <td className="no-translate notranslate">{tax?.grandTotal}</td>
        </tr>
      </table>
    </div>
  );
}

export default PriceDetailSection;
